import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";

function App() {
  return (
    <div>
      <Header />
      <div className='mt-20 '>
        <Home />
      </div>
      <Footer />
    </div>
  );
}

export default App;
